import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, Flex, Row, Col, Image } from "antd";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginValidationSchema } from "../../validations/authValidation";
import "../../Styles/login.css";
import Loader from '../../Components/Loader/Loader'
import useLogin from "../../services/hooks/useLogin";

const Login = () => {
  const [loading, setLoading] = useState(true);
  const [loginError, setLoginError] = useState(null);
  const [rememberValue, setRememberValue] = useState()
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [isLoading, error, handleLogin] = useLogin("auth/login");
  const { handleSubmit, control, formState: { errors } } = useForm({
    resolver: yupResolver(loginValidationSchema),
    mode: "onChange", // Ensure validation disappears when corrected
  });
  const navigate = useNavigate();
  const handleRedirectForget = () => {
    navigate('/forget-password');
  };

  const handleRedirectSignup = () => {
    setTimeout(() => {
      navigate('/signup')
    }, 700);
    setLoading(false);
  };

  // useEffect(() => {
  //   if (token) {
  //     console.log("Loginn page ", token)
  //     navigate("/dashboard");
  //   }
  // }, [token, navigate]);

  const onSubmit = async (values) => {
    console.log("login values:", values);
    setLoading(true);
    try {
      await handleLogin(values);
    } catch (error) {
      setLoginError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRememberChange = (e) => {
    console.log("checkbox value ", e)
    setRememberValue(e)
  }

  return (
    <Row justify="center" align="middle" gutter={16} className="form_section">
      {/* {loading && <Loader />} */}
      <Col md={12}>
        <div className="logo_image"></div>
      </Col>
      <Col md={12}>
        <Form
          className="login_form"
          name="login"
          layout="vertical"
          onFinish={handleSubmit(onSubmit)}
        >
          <h2>Log in!</h2>
          <p>Explore, learn, and grow with us. Let's begin your journey!</p>
          <hr className="my-4" />
          <Form.Item label="Email" validateStatus={errors.email ? "error" : ""} help={errors.email?.message}>
            <Controller
              name="email"
              control={control}
              render={({ field }) => <Input {...field} className="input_field" placeholder="Email" />}
            />
          </Form.Item>
          <Form.Item label="Password" validateStatus={errors.password ? "error" : ""} help={errors.password?.message}>
            <Controller
              name="password"
              control={control}
              render={({ field }) => <Input.Password {...field} className="input_field" placeholder="Password" />}
            />
          </Form.Item>

          {/* ✅ Remember Me & Forgot Password */}
          <Form.Item>
            <Flex justify="space-between" align="center">
              <Checkbox value='remember' onClick={(e) => handleRememberChange(e.target.checked)}>Remember me</Checkbox>
              <p onClick={handleRedirectForget} style={{ cursor: "pointer", color: "#4372C2", fontWeight: '500' }}>
                Forgot password
              </p>
            </Flex>
          </Form.Item>

          {/* ✅ Submit Button */}
          <Form.Item>
            <Button block type="primary" htmlType="submit" className="btn_submit">
              Log in
            </Button>
          </Form.Item>

          {/* ✅ Signup Redirect */}
          <div onClick={handleRedirectSignup} className="signup-link">
            Don't have an account?
            <span style={{ cursor: "pointer", color: "#4372C2", fontWeight: '500', paddingLeft: '10px' }}>
              Sign up
            </span>
          </div>
        </Form>
      </Col>
    </Row>
  );
};

export default Login;
